/**
 * Need help component that can be used in many places
 *
 * @module views/components/HelpSection
 * @memberof -Common
 */
import './HelpSection.scss';

import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Button from '@ulta/core/components/Button/Button';
import Link_Huge from '@ulta/core/components/Link_Huge/Link_Huge';
import Text from '@ulta/core/components/Text/Text';

export const HelpSection = ( props ) => {
  return (
    <div
      className={ classNames( 'HelpSection', {
        [`HelpSection--horizontal`]: props.horizontalLayout
      } ) }
    >
      <div className='HelpSection__Heading'>
        <Text htmlTag='h3'
          textStyle='body-1'
        >
          { props.headline }
        </Text>
        <Text htmlTag='p'
          textStyle='body-2'
          color='neutral-700'
        >
          { props.subHeadline }
        </Text>
      </div>
      { props.helpChannels && <div className='HelpSection__HelpLinks'>
        { props.helpChannels.map( ( helpLinks, index ) => {
          return (
            <div className='HelpSection__HelpLinksRow'
              key={ index }
            >
              { helpLinks.action.clientActionType === 'gladly::chatnow::click' ?
                (
                  <Button label={ helpLinks.primaryLabel }
                    likeLink
                    iconSize='s'
                    iconImage={ helpLinks.icon }
                    action={ helpLinks.action }
                    ariaHiddenIcon={ true }
                  />
                ) :
                (
                  <Link_Huge
                    withHover
                    target='_self'
                    action={ helpLinks.action }
                    iconImage={ helpLinks.icon }
                    iconsize={ 's' }
                    iconRight={ false }
                  >
                    { helpLinks.primaryLabel }
                  </Link_Huge>
                )
              }
              <Text htmlTag='span'
                textStyle='body-2'
                color='neutral-600'
              >
                { helpLinks.secondaryLabel }
              </Text>
            </div>
          );
        } ) }
      </div> }
    </div>
  );
};

/**
* Property type definitions
* @typedef HelpSectionProps
* @type {object}
* @property {string} example - refactor or delete
* @property {boolean} horizontalLayout - sets the horizontalLayout for helpSection
*/
export const propTypes = {
  headline: PropTypes.string.isRequired,
  subHeadline: PropTypes.string.isRequired,
  action: PropTypes.string,
  helpChannels: PropTypes.arrayOf(
    PropTypes.shape( {
      icon: PropTypes.string,
      primaryLabel: PropTypes.string,
      secondaryLabel: PropTypes.string
    } )
  ),
  horizontalLayout: PropTypes.bool
};

/**
* Default values for passed properties
*
* @type {object}
* @property {string} example='hello world' - The default refactor or delete
*/

HelpSection.propTypes = propTypes;

export default HelpSection;
